import * as THREE from "three";
import {EffectComposer} from "three/examples/jsm/postprocessing/EffectComposer";
import {RenderPass} from "three/examples/jsm/postprocessing/RenderPass";
import {UnrealBloomPass} from "three/examples/jsm/postprocessing/UnrealBloomPass";
import {SAOPass} from "three/examples/jsm/postprocessing/SAOPass";
import {SSAOPass} from "three/examples/jsm/postprocessing/SSAOPass";
import GameConfig from "../config";
import {isMobile} from "../utils/utils";

export default (game) => {

    const composer = new EffectComposer( game.threeRenderer );
    const renderPass = new RenderPass( game.threeScene, game.threeCamera );
    composer.addPass( renderPass );

    if(GameConfig.POST_PRO.SSAO.USE || (!isMobile() && GameConfig.POST_PRO.SSAO.USE_DESKTOP)){
        const ssaoPass = new SSAOPass( game.threeScene, game.threeCamera, window.innerWidth, window.innerHeight );
        ssaoPass.kernelRadius = GameConfig.POST_PRO.SSAO.KERNEL_RADIUS;
        ssaoPass.minDistance= GameConfig.POST_PRO.SSAO.MIN_DISTANCE;
        ssaoPass.maxDistance = GameConfig.POST_PRO.SSAO.MAX_DISTANCE;
        composer.addPass( ssaoPass );
    }

    if(GameConfig.POST_PRO.SAO) {
        const saoPass = new SAOPass( game.threeScene, game.threeCamera );
        saoPass.params.output = 0;
        saoPass.params.saoBias = 0.05;
        saoPass.params.saoIntensity = 0.18;
        saoPass.params.saoScale = 100;
        saoPass.params.saoKernelRadius = 100;
        saoPass.params.saoMinResolution = 0;
        saoPass.params.saoBlur = true;
        saoPass.params.saoBlurRadius = 8;
        saoPass.params.saoBlurStdDev = 4;
        saoPass.params.saoBlurDepthCutoff = 0.01
        composer.addPass( saoPass );
    }

    if(GameConfig.POST_PRO.BLOOM.USE){
        const bloomPass = new UnrealBloomPass(
            new THREE.Vector2( window.innerWidth, window.innerHeight ),
            GameConfig.POST_PRO.BLOOM.STRENGTH,
            GameConfig.POST_PRO.BLOOM.RADIUS,
            GameConfig.POST_PRO.BLOOM.THRESHOLD
        );
        composer.addPass( bloomPass );
    }
    return composer;
}